module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_02d.04f336cd.jpg";